import React from 'react';
import { Button, Typography, Container, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ErrorPage = ({ errorMessage = "Something went wrong." }) => {
  const navigate = useNavigate();

  const goToHomePage = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="sm" style={{ textAlign: 'center', marginTop: '10%' }}>
      <Typography variant="h3" color="error" gutterBottom>
        Oops! An Error Occurred
      </Typography>
      <Typography variant="body1" paragraph>
        {errorMessage}
      </Typography>
      <Typography variant="body2" color="textSecondary" paragraph>
        If you are still experiencing this issue, please contact our support team, or try again later.
      </Typography>

      <Box mt={4}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={goToHomePage} 
          style={{ marginRight: '10px',backgroundColor:"#07054F" }}
        >
          Go to Home Page
        </Button>
       
        <Button
          variant="text"
         sx={{color:"#07054F"}}
          href="mailto:support@flyzone.io"
        >
          Contact Support
        </Button>
      </Box>
    </Container>
  );
};

export default ErrorPage;
